import {debounce, throttle} from "../../../lib";
import Api from "../../../lib/api";

export default class SearchController {
	constructor($field, $panel, options = {}) {
		this.$field = $field;
		this.$panel = $panel;
		this.$input = null;
		this.$coursesContainer = null

		this.options = Object.assign({
			mobile: false
		}, options);

		this.id = this.$field.dataset.value || 'search-panel';
		this.activeScreenId = null;
		this.isProgress = false;

		this.FOCUS_SEARCH_INPUT_EVENT = 'focusSearchInput';
		this.CHANGE_SEARCH_INPUT_EVENT = 'changeSearchInput';
		this.CHANGE_SEARCH_PANEL_STATE_EVENT = 'changeSearchPanelState';

		this.init();
	}

	init() {
		if (!this.$field) {
			throw new Error('Courses Search Controller: Search field element is not defined.');
		}

		if (!this.$panel) {
			throw new Error('Courses Search Controller: Search panel element is not defined.');
		}

		this.defineViews();
		this.addEventListeners();
	}

	defineViews() {
		this.$input = this.$field.querySelector('.search-field_input');
		this.$coursesContainer = this.$panel.querySelector('.course-list');
	}

	addEventListeners() {
		this.addInputFocusListener();
		this.addInputBlurListener();
		this.addValueChangeListener();
		this.addChooseRecommendationListener();
	}

	subscribe(name, callback) {
		if (!name || !callback) return;

		this.$field.addEventListener(name, callback);
	}

	dispatchEvent(name, payload = null) {
		if (!name) return;

		this.$field.dispatchEvent(new CustomEvent(name, {
			'detail': payload
		}));
	}

	addInputFocusListener() {
		this.$input.addEventListener('focus', this.handleFocus.bind(this));
	}

	addInputBlurListener() {
		this.$input.addEventListener('blur', this.handleBlur.bind(this));
	}

	addValueChangeListener() {
		this.$input.addEventListener('input', debounce(this.handleValueChange.bind(this), 100));
	}

	addChooseRecommendationListener() {
		this.$panel.addEventListener('click', this.handleChooseRecommendation.bind(this));
	}

	handleFocus(e) {
		this.dispatchEvent(this.FOCUS_SEARCH_INPUT_EVENT, this.id);
		this.$field.classList.add('-focused');
	}

	handleBlur(e) {
		this.$field.classList.remove('-focused');
		e.target.value = e.target.value.trim();
	}

	handleValueChange(e) {
		const value = e.target.value.trim();

		if (value.length) {
			this.$field.classList.add('-filled');
			this.setProgressState();

			this.getSearchResult(value)
				.then((data) => {
					if (data) {
						this.$coursesContainer.innerHTML = data;
						this.changeSearchPanelState('result');
						lozadObserver.observe();
					} else {
						this.changeSearchPanelState('error');
					}
				})
				.catch((error) => {
					this.changeSearchPanelState('error');
					console.error('Courses Menu Error: Something went wrong with courses search. ' + error);
				});
		} else {
			this.$field.classList.remove('-filled');
			this.changeSearchPanelState('initial');
		}
	}

	handleChooseRecommendation(e) {
		const $target = e.target;

		if (!$target.classList.contains('recommendation-list_btn')) return;

		this.chooseRecommendation($target.innerText);
	}

	chooseRecommendation(text) {
		this.$input.value = text;
		this.$input.dispatchEvent(new Event('input'));
	}

	setProgressState() {
		if (this.isProgress) {
			return;
		}

		this.isProgress = true;
		this.$panel.classList.add('-progress');

		setTimeout(() => {
			this.$panel.classList.remove('-progress');
			this.isProgress = false;
		}, 1000);
	}

	changeSearchPanelState(stateName) {
		if (stateName !== 'initial' &&
			stateName !== 'result' &&
			stateName !== 'error'
		) {
			stateName = 'initial';
		}

		this.dispatchEvent(this.CHANGE_SEARCH_PANEL_STATE_EVENT, stateName);
		this.$panel.dataset.active = stateName;
	}

	setInputInitialState() {
		this.$input.value = '';
		this.$input.dispatchEvent(new Event('input'));
	}

	getSearchResult(text) {
		const csrfInput = document.getElementById('csrfToken');

		const requestParams = {
			[csrfInput.name]: csrfInput.value,
			cityId: craft.env.cityId,
			'query': text
		};

		if (this.options.mobile) {
			requestParams.mobile = true;
		}

		return Api.post(`${craft.env.apiSiteUrl}/feed/coursesSearch`, requestParams)
			.then((res) => {
				return res.data;
			});
	}
}